import { GUEST_PICKER_VALIDATION_RESET, GUEST_PICKER_VALIDATION_TRIGGER } from './actions';

export const initialState = {
  triggerValidation: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GUEST_PICKER_VALIDATION_TRIGGER: {
      return {
        ...state,
        triggerValidation: !state.triggerValidation,
      };
    }
    case GUEST_PICKER_VALIDATION_RESET: {
      return {
        ...state,
        triggerValidation: false,
      };
    }
    default:
      return state;
  }
};
